import React, { useContext } from "react";

const CurrentUserContext = React.createContext({});

const CurrentUserProvider = (props) => (
  <CurrentUserContext.Provider
    {...props}
  />
);

export const useCurrentUser = () => {
  const context = useContext(CurrentUserContext);

  if (context === undefined) {
    throw new Error("useCurrentUser must be used within a CurrentUserProvider");
  }

  return context;
};

export default CurrentUserProvider;
